jQuery(document).ready(function ($) {
    // image alt
    $('img').each(function () {
        var img = $(this);
        var src = $(this).attr('src');
        var alt = $(this).attr('alt');
        var filename = src.split('/').reverse()[0].replace(/\..+$/, '');
        if (img.parent('a').length !== 0) {
            console.log('parent is a link');
            if (alt === '' || alt === undefined) {
                img.attr('alt', 'image ' + filename);
            }
        } else {
            if (alt === '' || alt === undefined) {
                img.attr('alt', '');
            }
        }
    });

    // breadcrumbs
    $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

    //View More for Directory
    $('.bio-content-toggle').click(function () {
        var $bio = $(this).parent();
        var $toggletext = $(this).children('.text');

        if ($bio.hasClass('expanded')) {
            $bio.removeClass('expanded');
            $toggletext.text("View More");
        } else {
            $bio.addClass('expanded');
            $toggletext.text("View Less");
        }
    });

    $('.bio-content-toggle').on('keypress', function (e) {
        if (e.which === 13) {
            var $bio = $(this).parent();
            var $toggletext = $(this).children('.text');

            if ($bio.hasClass('expanded')) {
                $bio.removeClass('expanded');
                $toggletext.text("View More");
            } else {
                $bio.addClass('expanded');
                $toggletext.text("View Less");
            }
        }
    });



    //Set character limit on Blog cards
    $('.recent-posts .post .teaser p').each(function () {
        $(this).text(function (index, currentText) {
            if (currentText.length > 150) {
                return (currentText.substr(0, 150) + '...  ');
            }
        });
    });

    //Blog Categories
    $('.blog-category-title').click(function () {
        $('.blog-categories').toggleClass('active');
    });

    $('.blog-category-title').on('keypress', function (e) {
        if (e.which === 13) {
            $('.blog-categories').toggleClass('active');
            $('.blog-categories ul li *:visible:last').on('focusout', function () {
                $('.blog-categories').removeClass('active');
            });
        }
    });

    //Replace banner title with County Title
    if ($("h2.county-name").length) {
        $(".banner-wrapper h1").text($('h2.county-name').text());
        $('h2.county-name').remove();
    }

    if ($("h2.justice-name").length) {
        $(".banner-wrapper h1").text($('h2.justice-name').text());
        $('h2.justice-name').remove();
    }

    if ($("h2.history-on-trial-name").length) {
        $(".banner-wrapper h1").text($('h2.history-on-trial-name').text());
        $('h2.history-on-trial-name').remove();
    }

    // magnific popup
    $(document).ready(function () {
        $('main').magnificPopup({
            delegate: 'a.popup',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: 'title',
            }
        });
    });

    $(document).ready(function () {
        $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,

            fixedContentPos: false
        });
    });

    $('.gallery-link').on('click', function () {
        $(this).find('.gallery').magnificPopup('open');
    });

    $('.gallery').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });


    // popup single images
    // set links and titles (if needed)
    $('.popup-image').each(function () {
        var popupImageType = $(this).prop('nodeName');
        if (popupImageType === 'FIGURE') {
            imgSrc = $('img', this).attr('src');
            $(this).attr('title', 'Click to enlarge image').attr('tabindex', '0');
            if ($(this).children('a').length <= 0) {
                $('img', this).wrap($('<a>').attr('href', imgSrc)).closest('a');
            }
        }
    });
    $('.popup-image').each(function () {
        var popupImageType = $(this).prop('nodeName');
        if (popupImageType === 'A') {
            $(this).magnificPopup({
                type: 'image',
                image: {
                    markup: '<div class="mfp-figure"><div class="mfp-close"></div><div class="mfp-top-bar"></div><div class="mfp-img"></div><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-caption"></div><div class="mfp-counter"></div></div></div>',
                },
                verticalFit: true,
                tError: '<a href="%url%">The image</a> could not be loaded.'
            });
        } else if (popupImageType === 'FIGURE') {
            $('a', this).magnificPopup({
                type: 'image',
                titleSrc: 'alt',
                image: {
                    titleSrc: 'title',
                    markup: '<div class="mfp-figure"><div class="mfp-close"></div><div class="mfp-top-bar"></div><div class="mfp-img"></div><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-caption"></div><div class="mfp-counter"></div></div></div>',
                },
                callbacks: {
                    change: function () {
                        $(this.content).find('.mfp-caption').html($(this.currItem.el).find('img').attr('alt'));
                        $(this.content).find('.mfp-title').html($(this.currItem.el).next().html());
                    }
                },
                verticalFit: true,
                tError: '<a href="%url%">The image</a> could not be loaded.'
            });
        }
    });
    // popup multiple images
    $('.popup-images').each(function () {
        var popupImageType = $(this).prop('nodeName');
        if (popupImageType === 'FIGURE') {
            imgSrc = $('img', this).attr('src');
            $(this).attr('title', 'Click to enlarge image').attr('tabindex', '0');
            if ($(this).children('a').length <= 0) {
                $('img', this).wrap($('<a>').attr('href', imgSrc)).closest('a');
            }
        }
    });
    $('.popup-images').magnificPopup({
        delegate: 'a',
        type: 'image',
        titleSrc: 'alt',
        image: {
            titleSrc: 'title',
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><div class="mfp-top-bar"></div><div class="mfp-img"></div><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-caption"></div><div class="mfp-counter"></div></div></div>',
        },
        callbacks: {
            change: function () {
                $(this.content).find('.mfp-caption').html($(this.currItem.el).find('img').attr('alt'));
                $(this.content).find('.mfp-title').html($(this.currItem.el).next().html());
            }
        },
        gallery: {
            enabled: true,
            preload: [0, 2]
        },
        verticalFit: true,
        tError: '<a href="%url%">The image</a> could not be loaded.'
    });
    // gallery images
    $('.popup-gallery figure').each(function () {
        imgSrc = $('img', this).attr('src');
        $(this).attr('title', 'Click to enlarge image').attr('tabindex', '0');
        if ($(this).children('a').length <= 0) {
            $('img', this).wrap($('<a>').attr('href', imgSrc)).closest('a');
        }
    });
    $('.popup-gallery').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            titleSrc: 'alt',
            image: {
                titleSrc: 'title',
                markup: '<div class="mfp-figure"><div class="mfp-close"></div><div class="mfp-top-bar"></div><div class="mfp-img"></div><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-caption"></div><div class="mfp-counter"></div></div></div>',
            },
            callbacks: {
                change: function () {
                    $(this.content).find('.mfp-caption').html($(this.currItem.el).find('img').attr('alt'));
                    $(this.content).find('.mfp-title').html($(this.currItem.el).next().html());
                }
            },
            gallery: {
                enabled: true,
                preload: [0, 2]
            },
            verticalFit: true,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        });
    });
    //Set character limit on History on Trial cards
    $('.history-on-trial-list li p').each(function () {
        $(this).text(function (index, currentText) {
            if (currentText.length > 100) {
                return (currentText.substr(0, 100) + '...  ');
            }
        });
    });


    if (window.location.href.indexOf('case-details') > -1){
    $('body').addClass('case-details');
    };

    // if (window.location.href.indexOf('county-details') > -1){
    //     $('body').addClass('county-details');
    //     };
   
        $("a.view-all-button").click(function () {
            $("div.collapsed").removeClass("collapsed");
            $("a.view-all-button").addClass("hide-view-all");
        });
   
});

//Tables
$('#main').responsiveTables();